import { Dropdown, IconButton, Modal, ResponsiveMode } from "@fluentui/react";
import React from "react";
import { ScrollableFormTree } from "../../../cpm/FormTree";
import { formatMessage } from "../../../../utils/helpers/LanguageHelper";
import { SourceTypeEnum } from "../../../../api/models/source-type-enum";
import useFormDropDown from "./FormDropDownHook";

export const FormDropDown = (input) => {
  const {
    form,
    onRenderCaretDown,
    setState,
    state,
    dbApplication,
    objectSource,
    isModalOpen,
    contentStyles,
    iconButtonStyles,
    cancelIcon,
    onFormClick,
    isComponentInstance,
    isLocked,
  } = useFormDropDown(input);

  return (
    <>
      <Dropdown
        id="form_dropdown"
        placeholder={form ? `${form.code} - ${form.desc}` : formatMessage("cof.base.select")}
        label={formatMessage("cof.createnewobject.form")}
        onRenderCaretDown={onRenderCaretDown}
        options={[]}
        onClick={() => !isComponentInstance && setState({ ...state, isModalOpen: true })}
        responsiveMode={ResponsiveMode.large}
        disabled={(dbApplication == null && objectSource !== SourceTypeEnum.EXCEL) || isComponentInstance || isLocked}
        required
      />
      {dbApplication ? (
        <Modal
          titleAriaId={"titleId"}
          isOpen={isModalOpen}
          onDismiss={() => setState({ ...state, isModalOpen: false })}
          isBlocking={false}
          containerClassName={contentStyles.container}
          styles={{
            main: {
              minHeight: "100%",
              minWidth: "100%",
            },
          }}
        >
          <div className={contentStyles.header}>
            <span id={"titleId"}>Form</span>
            <IconButton
              styles={iconButtonStyles}
              iconProps={cancelIcon}
              ariaLabel="Close popup modal"
              onClick={() => setState({ ...state, isModalOpen: false })}
            />
          </div>
          <div className={contentStyles.body}>
            <ScrollableFormTree
              onFormClick={onFormClick}
              dbId={dbApplication.id as string}
              oidPath={form ? form.oidPath : undefined}
            />
          </div>
        </Modal>
      ) : null}
    </>
  );
};
